// extracted by mini-css-extract-plugin
export default {"headline":"Contact_headline__0nZHW","title":"Contact_title__K2KDn","numbers":"Contact_numbers__vPWAl","contact":"Contact_contact__duqYr","link":"Contact_link__gikVH"};